import { useMemo } from "react";
import { QRCodeSVG } from "qrcode.react";
import { formatIDR } from "../../../utils/helpers/formatIDR";
import { createDynamicQrisPayload, getQrisMerchantName } from "../../../utils/helpers/qris";
import { getStoreQrisPayload, normalizeStoreSetting } from "../../../utils/helpers/storeSetting";

const PaymentQrisPanel = ({ amount, storeSetting }) => {
  const store = normalizeStoreSetting(storeSetting);
  const payload = getStoreQrisPayload(store, "");
  const merchantName = getQrisMerchantName(payload, store?.name || "Toko");

  const dynamicQris = useMemo(() => {
    if (!payload) {
      return {
        value: null,
        error: "QRIS toko belum dikonfigurasi. Upload QRIS statis di Konfigurasi Toko.",
      };
    }

    if (Number(amount || 0) <= 0) {
      return { value: null, error: "Isi nominal pembayaran untuk membuat QRIS dinamis." };
    }

    try {
      return { value: createDynamicQrisPayload(payload, amount), error: null };
    } catch (error) {
      return { value: null, error: error?.message || "QRIS dinamis gagal dibuat." };
    }
  }, [amount, payload]);

  if (!dynamicQris.value) {
    return (
      <div className="alert alert-warning mb-0" role="alert">
        <strong>QRIS belum dapat ditampilkan.</strong>
        <div className="small mt-1">{dynamicQris.error}</div>
      </div>
    );
  }

  return (
    <div className="akas-payment-qris-panel">
      <div className="akas-payment-qris-code">
        <QRCodeSVG
          value={dynamicQris.value}
          size={190}
          level="M"
          marginSize={2}
          fgColor="#0B2D32"
          bgColor="#FFFFFF"
          title={`QRIS ${merchantName} sebesar ${formatIDR(amount)}`}
          style={{ width: "100%", height: "auto" }}
        />
      </div>
      <div className="flex-fill">
        <div className="text-uppercase text-primary small fw-bold">QRIS dinamis siap dipindai</div>
        <div className="h3 mb-1">{merchantName}</div>
        <div className="text-secondary small">Nominal sudah tertanam otomatis di dalam QR.</div>
        <div className="akas-payment-qris-total">{formatIDR(amount)}</div>
        <div className="text-secondary small">Konfirmasi pembayaran setelah customer menunjukkan bukti berhasil.</div>
      </div>
    </div>
  );
};

export default PaymentQrisPanel;
